import React, { Component } from 'react';
import { Container, Alert, Row, Col, Button } from 'reactstrap';
import RouteMap from './Map'
import CurrentRoute from './Route'
import Register from './Register'
import { Route } from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Loading from '../Utilities/Loading'
import Summary from './EventSummary'
import { Redirect } from 'react-router-dom'
import { generateRoute } from '../../redux/actions/UserActions'

class Event extends Component {

  constructor(props){
      super(props);
      this.state= {};
  }

  handleClick = (e) => {
    e.preventDefault();
    console.log("Local click")
    this.props.generateRoute(this.props.event[0]);
  }

  render() {
    const { auth, event, signup, riders } = this.props;
    console.log(this.props)
    
    const path = window.location.pathname
    const eventID = path.substr(path.lastIndexOf('/')+1);
    
    if (!auth.uid) return <Redirect to='/login' />
    if (!event || !signup || !riders){
        return <div><Loading></Loading></div>
    }

    return (
      <div>
        <br></br>
        <Container>
          <h1 className="text-center"> Event Details </h1>
          <br></br>
          <Row>
            <Col md="8" sm="12">
                <RouteMap event={event[0]} riders={riders}></RouteMap><br/>
            </Col>
            <br></br>
            <br></br>
            <Col md="4" sm="12">
              <Summary event={event[0]}></Summary><br/>
              { (event[0].owner.toString() === auth.uid.toString() && this.props.event[0].open) ? (
                <div><Button color='success' size='lg' onClick={this.handleClick}>
                  Generate Route
                </Button><br/><br/></div>
              ) : <div/>}
              { (this.props.signup.length === 0) ? <Register event={event[0]} /> : 
              ( (this.props.event[0].open) ? (
                <Alert>
                <h2>You are registered for this event.</h2>
                <h4><small class="text-muted">Please wait for the owner to finalize the route.</small></h4>
              </Alert>) : <CurrentRoute people={this.props.riders} event={this.props.event[0]}
                                        signup={this.props.signup[0]}/>
              )}
                <br></br>
            </Col>
          </Row><br/>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      generateRoute: (event) => dispatch(generateRoute(event))
  }
}

const mapStateToProps = (state) => {
    console.log(state);
    return {
        auth: state.firebase.auth,
        event: state.firestore.ordered.events,
        signup: state.firestore.ordered.group,
        riders: state.firestore.ordered.pin
    }
  }
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        const path = window.location.pathname
        const eventID = path.substr(path.lastIndexOf('/')+1);
        if (!props.auth.uid) return [];
        return [
           { collection: 'events', doc: eventID},
           { collection: 'participants', storeAs: 'group', where: [['user', '==', props.auth.uid],
              ['eventID', '==', eventID.toString()]]},
           {collection: 'participants', storeAs: 'pin', where: ['eventID', '==', eventID.toString()]}
        ]
    })
  )(Event)

